import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import Loader from "@componentsShared/Loader/Loader";
import UserEditMobileComponent from "@/pages/user/UserAccountComponent/components/MyInfoComponent/UserEditMobileComponent/UserEditMobileComponent";
import useFullLoading from "@hooks/useFullLoading";
var UserEditMobile = function UserEditMobile() {
  var loading = useFullLoading();
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    mobileHasBack: true,
    hideFooter: true
  }, /*#__PURE__*/React.createElement(UserEditMobileComponent, null));
};
export default UserEditMobile;